module.exports = __webpack_public_path__ + "img/fin.5aca3662.png";